import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "../../../axios";
import moment from "moment";
import { Link } from "react-router-dom";
import { SubjectIcon } from "../../../SubjectIcon";
import { Tooltip } from "@mui/material";
import { BookText, CalendarDays } from "lucide-react";
import { shortenParagraph } from "../../../utils/Engagement";
import PublishedQListPreRead from "../Pending/PublishedQListPreRead";

// const timeHelper = (a) => {
//   const dateObj = new Date(a);
//   const day = dateObj.getUTCDate();
//   const month = dateObj.getUTCMonth() + 1;
//   const year = dateObj.getUTCFullYear();
//   const hours = dateObj.getUTCHours();
//   const minutes = dateObj.getUTCMinutes();
//   const seconds = dateObj.getUTCSeconds();
//   const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//   return outputDateString;
// };

export default function Completed({ setHomeMain, filter }) {
  const [completedCard, setCompletedCard] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isGettingData, setIsGettingData] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, '0');
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  useEffect(() => {
    const completedBox = async () => {
      let response = await axios.get(
        `/homework/preRead/filterByStudentId/${currentUser?.id}/completed?_page=${filter?.page}&_limit=${filter?.limit}&sortBy=${filter?.sortBy}` +
        `${filter?.date
          ? `&date=${moment(filter?.date).format("YYYY-MM-DD")}`
          : ``
        }` +
        `${filter?.time ? `&time=${filter?.time}` : ``}` +
        `${filter?.subjectId?.length !== 0
          ? `&subjectId=${filter?.subjectId}`
          : ``
        }`
      );

      response && setCompletedCard(response.data.data);
      setIsGettingData(false);
    };
    completedBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);


  return (
    <div>
      <div>
        {completedCard?.length > 0 ? (
          <div className="d-flex justify-content-start gap-3  flex-wrap">
            {completedCard?.map((card, index) => (
              <div
                onClick={() => {
                  setIsPopupOpen(true);
                  setSelectedId(card?.id);
                }}
              >
                <div
                  key={index}
                  // className="summarySubBoxContainerHW"
                  className="w-80 h-32 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4 cursor-pointer card_style"
                  style={{
                    borderTop: `8px solid #${card?.subject_id?.subject_color}`,
                  }}
                >
                  <div
                    className="d-flex SubsummarySubBoxContainer justify-content-between align-items-center"
                  >
                    <div>
                      <div className="subboxSubjectName">
                        {card?.subject_id?.name}
                      </div>
                    </div>
                    <div>
                      <img
                        src={`${SubjectIcon?.find(
                          (i) => i.subjectName === card?.subject_id?.name
                        )?.icon
                          }`}
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-start">
                    <div className="d-flex align-items-center">
                      {/* <img src="/HwImg/FileIconPreRead.png" alt=""></img> */}
                    </div>
                    <div>
                      {/* <div className="subjectPreRead">{card?.subject_id?.name}</div> */}
                      <div className="SubChapName">{
                        <Tooltip
                          title={card?.name}
                          arrow
                          placement="bottom"
                          enterDelay={200}
                          leaveDelay={100}
                        >
                          <div className="flex">
                            <BookText size={16} className="me-2 mt-1 text-dark" />
                            {shortenParagraph(card?.name, 35)}
                          </div>
                        </Tooltip>}</div>
                      <div className="PreReadDeadline flex mt-2">
                        <CalendarDays size={16} className="me-2 text-dark" />
                        Updated On: {timeHelper(card?.submitted_on)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {
              isPopupOpen && (
                <PublishedQListPreRead
                  publishPre_id={selectedId}
                  setIsPopupOpen={setIsPopupOpen}
                />
              )
            }
          </div>
        ) : isGettingData ? (
          <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
        ) : (
          <span>PreRead Not Found</span>
        )}
      </div>
    </div>
  );
}
